"use client";

import { useEffect, useState } from "react";

/**
 * Inlined rather than added to css/animations.css: this screen is the only
 * consumer, and keeping the keyframes next to the element that uses them means
 * the whole component stays readable in one place. Prefixed `ls-` because
 * keyframe names are global.
 */
const BREATHE_KEYFRAMES = `
@keyframes ls-breathe {
	0%, 100% {
		transform: scale(1);
		opacity: 1;
	}
	50% {
		transform: scale(1.05);
		opacity: 0.8;
	}
}
`;

const LoadingScreen = () => {
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	if (!mounted) {
		return null;
	}

	return (
		<div className="bg-background flex min-h-screen items-center justify-center">
			<style>{BREATHE_KEYFRAMES}</style>
			<img
				src="/single_512x512.png"
				alt="Loading"
				className="size-[210px]"
				style={{ animation: "ls-breathe 1s ease-in-out infinite" }}
			/>
		</div>
	);
};

export default LoadingScreen;
